<div [style.background-color]="appTheme ? appTheme : '#bbccdd'">
    <div [class.loader]="show">
        <app-loader></app-loader>
    </div>
    <router-outlet></router-outlet>
    <router-outlet name="modal"></router-outlet>
</div>